import { isProd } from './Environment'

const emptyFunc = () => {}

const functions = {
  log: isProd ? console.debug : console.log,
}

const logger = new Proxy(functions.log, {
  get(target, prop) {
    return functions[prop] || target[prop]
  },
})

export const debug = isProd ? emptyFunc : console.debug
functions.debug = debug

export const info = console.info
functions.info = info

export const warn = console.warn
functions.warn = warn

export const error = console.error
functions.error = error

export const log = functions.log
globalThis.logger = logger

export { logger }
